import { Lock, Password, Visibility, VisibilityOff } from "@mui/icons-material";
import { Button, Grid, IconButton } from "@mui/material";
import React, { useState } from "react";
import { connect } from "react-redux";
import ValidationService from "easy-validation-service";
import { changePassword } from "../../store/actions/auth";
import useForm from "../../store/hooks/useForm";
import Input from "../forms/Input";
import AnalyticsCard from "../ui/AnalyticsCard";

function ChangePasswordForm({ loading, changePassword }) {
  const [togglePasswords, setTogglePasswords] = useState(false);
  const formConfig = useForm({
    oldPassword: {
      defaultValue: "",
      validators: [
        (value) =>
          ValidationService.validateString({
            value,
            min: 8,
            max: 16,
            noWhiteSpace: true,
          }),
        (value, data) => value !== data.password.value,
      ],
      onChange: ({ fieldValue, form, fieldName }) => {
        return {
          [fieldName]: fieldValue,
          verifyPassword: form.verifyPassword.value,
          oldPassword: form.oldPassword.value,
        };
      },
    },
    verifyPassword: {
      defaultValue: "",
      validators: [
        (value) =>
          ValidationService.validateString({
            value,
            min: 8,
            max: 16,
            noWhiteSpace: true,
          }),
        (value, data) => {
          return value === data.password.value;
        },
      ],
      onChange: ({ fieldValue, form, fieldName }) => {
        return { [fieldName]: fieldValue, password: form.password.value };
      },
    },
    password: {
      defaultValue: "",
      validators: [
        (value) =>
          ValidationService.validateString({
            value,
            min: 8,
            max: 16,
            noWhiteSpace: true,
          }),
        (value, form) => form.oldPassword.value !== value,
      ],
      onChange: ({ fieldValue, form, fieldName }) => {
        return {
          [fieldName]: fieldValue,
          oldPassword: form.oldPassword.value,
          verifyPassword: form.verifyPassword.value,
        };
      },
    },
  });
  return (
    <>
      <AnalyticsCard
        title={"Change Password"}
        icon={<Lock />}
        divider
        sx={{ height: "100%" }}
      >
        <Grid container spacing={2}>
          <Grid item md={12} xs={12}>
            <Input
              {...formConfig.form.oldPassword}
              label={"Current password"}
              name="oldPassword"
              type={togglePasswords ? "text" : "password"}
              onChange={formConfig.handleChange}
              value={formConfig.form.oldPassword.value}
              iconAction={() => setTogglePasswords((prev) => !prev)}
              endIcon={
                togglePasswords ? (
                  <IconButton color="primary">
                    <VisibilityOff />
                  </IconButton>
                ) : (
                  <IconButton color="primary">
                    <Visibility />
                  </IconButton>
                )
              }
            />
          </Grid>
          <Grid item md={12} xs={12}>
            <Input
              {...formConfig.form.password}
              label={"New password"}
              name="password"
              type={togglePasswords ? "text" : "password"}
              onChange={formConfig.handleChange}
              value={formConfig.form.password.value}
              iconAction={() => setTogglePasswords((prev) => !prev)}
              endIcon={
                togglePasswords ? (
                  <IconButton color="primary">
                    <VisibilityOff />
                  </IconButton>
                ) : (
                  <IconButton color="primary">
                    <Visibility />
                  </IconButton>
                )
              }
            />
          </Grid>
          <Grid item md={12} xs={12}>
            <Input
              {...formConfig.form.verifyPassword}
              label={"Verify password"}
              name="verifyPassword"
              type={togglePasswords ? "text" : "password"}
              onChange={formConfig.handleChange}
              value={formConfig.form.verifyPassword.value}
              iconAction={() => setTogglePasswords((prev) => !prev)}
              endIcon={
                togglePasswords ? (
                  <IconButton color="primary">
                    <VisibilityOff />
                  </IconButton>
                ) : (
                  <IconButton color="primary">
                    <Visibility />
                  </IconButton>
                )
              }
            />
          </Grid>
          <Grid item md={12} xs={12} justifyContent="center" display="flex">
            <Button
              startIcon={<Password />}
              disabled={loading || !formConfig.isValid || !formConfig.isTouched}
              variant="contained"
              onClick={async () => {
                const res = await changePassword(formConfig.getFormValues());
                if (res) {
                  formConfig.resetForm();
                }
              }}
            >
              Change Password
            </Button>
          </Grid>
        </Grid>
      </AnalyticsCard>
    </>
  );
}

export default connect(({ auth }) => ({ loading: auth.loading }), {
  changePassword,
})(ChangePasswordForm);
